export const MOUSEOVER = 'mouseover';
export const HOVER = 'hover';
export const DWELL = 'dwell';

export const VIEWABILITY_CHANGED = 'viewability-changed';

export const AD_STARTED = 'ad-started';
export const AD_INITIALISED = 'ad-initialised';
export const AD_LOADED = 'ad-loaded';
export const AD_STATE_CHANGED = 'ad-state-changed';

export const VIEW = 'view';
export const TIME_IN_VIEW = 'time-in-view';

export const EXPAND = 'expand';
export const EXPAND_CLOSE = 'expand-close';
export const EXPAND_DWELL = 'expand-dwell';

export const CAROUSEL_SLIDE_VIEW = 'slide-view';

export const SWITCH_ARTBOARD = 'switch-artboard';

export const TIMELINE_START = 'timeline-start';
export const TIMELINE_PERCENT_PLAYED = 'timeline-percent-played';
export const TIMELINE_ENDED = 'timeline-ended';
export const TIMELINE_COMLETED = 'timeline-completed';
export const TIMELINE_LOOPED = 'timeline-looped';

export const VIDEO_RESTART = 'restart';
export const VIDEO_START = 'start';
export const VIDEO_PERCENT_PLAYED = 'percent-played';
export const VIDEO_SEEK_START = 'seek-start';
export const VIDEO_SEEK_END = 'seek-end';
export const VIDEO_END = 'end';
export const VIDEO_PLAY = 'play';
export const VIDEO_PAUSE = 'pause';
export const VIDEO_SOUND = 'sound';
export const VIDEO_ERROR = 'error';
export const VIDEO_ENTER_FULLSCREEN = 'enter-fullscreen';
export const VIDEO_EXIT_FULLSCREEN = 'exit-fullscreen';

export const WIPEAWAY_START = 'wipeaway-start';
export const WIPEAWAY_COMPLETE = 'wipeaway-complete';



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Render/tracking/constants/events.js